module.exports = __webpack_public_path__ + "img/booking.8cf23863.png";